var styles = {
  "Backdrop": "Online-Store-UI-Backdrop_1srg6",
  "show": "Online-Store-UI-Backdrop--show_bxjiu",
  "fullscreen": "Online-Store-UI-Backdrop--fullscreen_gjrei"
};

export { styles as default };
